import { useState, useContext } from "react";
import { GameState } from "../GameState";
import LocationMenuButton from "./LocationMenuButton";
import UpgradeLaunderButton from "./UpgradeLaunderButton";

const UpgradeMenu = (props) => {
  const state = useContext(GameState);
  const { id } = props;
  const [ selected, setSelected ] = useState(false);

  return (
    <div className="upgrademenu">
      <LocationMenuButton name="UPGRADES" action={() => setSelected(!selected)} />
      {selected && <UpgradeLaunderButton id={id} />}
    </div>
  );
};

export default UpgradeMenu;
